<template>
  <div class="promopanel">
    <CommonHead></CommonHead>
    <b-modal
      id="cart_notificaion"
      ref="cartmodal"
      :title="this.cartOrderMsg"
      title-tag="h3"
      ok-only
      modal-class="common_pop cart_notificaion"
    ></b-modal>
    <div class="container">
      <div class="promopage">
        <a @click="togglepromo" class="ordershow" href="javascript:;"
          >Summary<b-img
            class="plusfil"
            src="/shop/images/add.svg"
            alt="add"
          ></b-img
          ><b-img
            class="minusfil"
            src="/shop/images/minus.svg"
            alt="minus"
          ></b-img
        ></a>
        <div class="leftpromo">
          <h1>Summary</h1>
          <div class="promodata">
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 1 && selectedFabricTypeName.length"
                class="commondata-div firstset"
              >
                <h3>Fabric Type:</h3>
                <p>{{ selectedFabricTypeName }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 2 && selectedFabricNameValue.length"
                class="commondata-div secondset"
              >
                <h3>Fabric Name:</h3>
                <p>
                  {{ selectedFabricNameValue }} /
                  {{
                    selectedFabricColorName.length
                      ? selectedFabricColorName
                      : "No Color Selected"
                  }}
                </p>
                <transition name="slide-fade">
                  <b-img
                    class="selectedimg"
                    v-show="currentStep >= 2 && selectedFabricColorImg.length"
                    :src="selectedFabricColorImg || ''"
                    fluid
                    alt="image"
                  ></b-img>
                </transition>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div"
              >
                <h3>Top Styles</h3>
                <p>
                  <span>Style:</span><span> {{ selectedStyleName }}</span>
                </p>
                <p v-show="styleOptionVisiblity.grommet">
                  <span>Color & Size:</span>
                  <span>{{ styleOptionNames.grommet }}</span>
                </p>
                <p v-show="styleOptionVisiblity.pin">
                  <span>Pin Setting:</span>
                  <span> {{ styleOptionNames.pin }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="
                  currentStep >= 4 &&
                  styleSelectedDone &&
                  selectedFabricType != 'Sheer'
                "
                class="commondata-div"
              >
                <h3>Panels & Pairs:</h3>
                <p>
                  <span>Panels / Pairs Qty:</span
                  ><span> {{ panelpairQtyName }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div"
              >
                <h3>Measurements:</h3>
                <p>
                  <span>Left Return:</span><span>{{ leftReturnValue }}"</span>
                </p>
                <p>
                  <span>Right Return:</span><span>{{ rightReturnValue }}"</span>
                </p>
                <p>
                  <span>Overlap:</span><span>{{ overlapValue }}"</span>
                </p>
                <p>
                  <span>Finished Length:</span
                  ><span>{{ finishedLength }}"</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4"
                class="commondata-div"
              >
                <h3>Lining</h3>
                <p>
                  <span>Lining:</span
                  ><span> {{ liningselectMap[liningselect] }}</span>
                </p>
                <p v-show="blackoutguard">
                  <span>BlackoutGuard&trade;:</span
                  ><span> {{ (blackoutguard == true) ? "Yes" : "No" }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div"
              >
                <p>
                 <span>Project Name:</span
                  ><span> {{ line }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div"
              >
                <p>
                  <span>Notes:</span
                  ><span> {{ customernotes }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div"
              >
                <h3 class="font-weight-bold">Suggested Retail Charges:</h3>
                <p>
                  <span>Base Price:</span>
                  <span>${{ basePrice }}</span>
                </p>
                <p>
                  <span>Lining Surcharge:</span>
                  <span>${{ interliningSurcharge }}</span>
                </p>
                <p v-show="blackoutguardCost > 0">
                  <span>BlackoutGuard&trade; Surcharge:</span>
                  <span>${{ blackoutguardCost }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div lastpricediv"
              >
                <p class="font-weight-bold text-left">
                  <span>Suggested Retail (ea):</span><span>${{ (rawDiscountedAmount * 2).toFixed(2) }}</span>
                </p>
                <p class="font-weight-bold text-left">
                  <span>Wholesale (ea):</span><span> {{ calculationValue }}</span>
                </p>
              </div>
            </transition>
            <div
              v-show="currentStep >= 4 && styleSelectedDone"
              class="quantity-div"
            >
              <span>Qty:</span>
              <div class="samediv quantity">
                <div class="qtydiv">
                  <span @click="decrement">-</span>

                  <input
                    type="number"
                    :value="qty"
                    @change="onChangeQTY"
                    @blur="onChangeQTY"
                    step="1"
                  />

                  <span @click="increment" class="lastspan">+</span>
                </div>
              </div>
            </div>
            <h3 v-show="currentStep >= 4 && styleSelectedDone">
              Subtotal:<span>${{ (qty * rawCalculation).toFixed(2) }}</span>
            </h3>
            <div class="promo-btns">
              <b-button
                type="submit"
                class="AddTOCartBtn"
                :disabled="!canSave || !styleSelectedDone"
                variant="dark"
                @click="addtocartpanel">
                {{ this.$route.query.hasOwnProperty('cart') ? "Update Cart" : "Add to cart"}}
              </b-button>
              <b-button
                :disabled="!canSave || !styleSelectedDone"
                @click="saveToProject"
                variant="outline-primary"
              >
                <b-img
                  class="saveproject"
                  src="/shop/images/bookmark.svg"
                  fluid
                  alt="save image"
                ></b-img>
                <b-img
                  class="saveproject white"
                  src="/shop/images/bookmark-white.svg"
                  fluid
                  alt="save image"
                ></b-img
                >{{
                  this.$route.params.id
                    ? "Update Project Item"
                    : "Save to Projects"
                }}
              </b-button>
              <b-button
                :disabled="!canSave"
                @click="printQuote"
                class="printQuoteModelBtn"
                variant="outline-primary"
              >Print Quote</b-button>
            </div>
          </div>
        </div>
        <div class="rightpromo">
          <h1>10 Day Quick Ship</h1>
          <b-form class="commonform">
            <div class="availabledata">
              <ul class="avail_data">
                <li>
                  <a href="javascript:;"
                    ><span>Fabric Type</span>
                    <v-select
                      :options="fabrictype"
                      label="text"
                      :clearable="false"
                      :searchable="false"
                      @input="loadNames"
                      v-model="fabrictype_value"
                      placeholder="Please Select Fabric Type"
                    ></v-select>
                  </a>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a
                    href="javascript:;"
                    @click="toggleColors"
                    v-bind:class="{ collapsed: !colorCollapsed }"
                    ><span>Fabric Name</span>
                    <v-select
                      :options="fabricname"
                      label="text"
                      :clearable="false"
                      :searchable="false"
                      @input="loadColors"
                      v-model="selectedFabricName"
                      placeholder="Please Select Fabric Name"
                    ></v-select>
                    <md-progress-spinner
                      v-show="loadingName || loadingColor"
                      style="stroke: #aaa; margin-left: auto"
                      :md-stroke="3"
                      :md-diameter="24"
                      md-mode="indeterminate" />
                    <b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="fabric-name" v-model="colorCollapsed">
                    <h3>Select Color</h3>
                    <div class="select-color">
                      <a
                        href="javascript:;"
                        v-for="color in fabriccolors"
                        :key="color['INVENTCOLORID']"
                        @click="selectColor(color)"
                        v-bind:class="{
                          'image-name-box': true,
                          selected:
                            color['INVENTCOLORID'] === selectedFabricColor,
                        }"
                      >
                        <div class="image-box">
                          <b-img
                            class="colorimg"
                            :src="color['IMAGE']"
                            fluid
                            alt="image"
                          ></b-img>
                        </div>
                        <h4>{{ color["COLORNAME"] }}</h4>
                        <h6 class="text-left">{{ color["STATUS"] }}</h6>
                        <h6 class="text-left">{{color["QTYONHAND"]}} {{ color['STATUS'] == 'Active' ? 'yards in stock' : 'yards remaining' }}</h6>
                      </a>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 4 }">
                  <a href="javascript:;" v-b-toggle.top-style
                    >Top Styles<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="top-style">
                    <h3 class="regularfont">Select Style:</h3>
                    <div class="select-radio">
                      <md-radio
                        v-for="style in styles"
                        :key="style.id"
                        v-model="selectedStyle"
                        @change="onStyleSelect"
                        :name="style.id"
                        :value="style.id"
                        ><b-img
                          class="lining-img"
                          :src="style.image"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>{{ style.name }}</p></md-radio
                      >
                    </div>
                    <h3 v-show="styleOptionVisiblity.grommet" class="regularfont">
                      Grommet Color
                    </h3>
                    <div v-show="styleOptionVisiblity.grommet" class="select-radio">
                        <md-radio
                          @change="onGrommetColorChange"
                          v-for="(grommet, index) in grommetByColor.colors"
                          :key="index"
                          v-model="selectedGrommetColor"
                          :name="grommet"
                          :value="grommet"
                          ><b-img
                            class="lining-img"
                            :src="grommetByColor.sizes[grommet][0].image"
                            fluid
                            alt="rm-sateen-white image"
                          ></b-img>
                          <p>{{ grommet }}</p></md-radio
                        >
                      </div>
                      <div v-show="styleOptionVisiblity.grommet" class="gromet-color">
                        <span class="flex-column align-items-start">Select Grommet Size <span style="color:#f00">(Inside diameter)</span></span>
                        <v-select
                          @input="onGrommetSizeChange"
                          :options="
                            selectedGrommetColor == null
                              ? []
                              : grommetByColor.sizesIds[selectedGrommetColor]
                          "
                          label="name"
                          :clearable="false"
                          :searchable="false"
                          v-model="selectedGrommetSize"
                          placeholder="Please Select Gromet Size"
                        ></v-select>
                      </div>
                    <h3 v-show="styleOptionVisiblity.pin" class="regularfont">
                      Pin Setting:
                    </h3>
                    <div v-show="styleOptionVisiblity.pin" class="select-radio">
                      <md-radio
                        @change="remapNamesToStyle"
                        v-for="pin in staticOptions.pin"
                        :key="pin.PinSetDesc"
                        v-model="styleOptionValues.pin"
                        :name="pin.PinSetDesc"
                        :value="pin.PinSetSize"
                        class="md-radio-override"
                      >
                        <p>{{ pin.PinSetDiscFull }}</p></md-radio
                      >
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.panel-qty
                    >Panels/ Pairs Qty<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="panel-qty">
                    <div class="select-radio">
                      <md-radio
                        v-for="quantity in quantities"
                        :key="quantity['Description']"
                        @change="onPanelPairSelect"
                        v-model="panelpairQty"
                        :name="quantity['Description']"
                        :value="quantity['Widths']"
                        v-bind:class="{
                          'md-radio-override': !quantity['image'],
                        }"
                      >
                        <b-img
                          class="qty-img"
                          v-if="quantity.image"
                          :src="'/shop/attachments/promo/' + quantity.image"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>{{ quantity.Description }}</p></md-radio
                      >
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.measurements
                    >Measurements<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="measurements">
                    <div class="measurement-div">
                      <div class="length-div">
                        <span>Left Return: </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model="leftReturnValue"
                            name="left-return"
                            disabled="disabled"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Overlap: </span>
                        <md-field>
                          <md-input
                            type="number"
                            @input="calculateFW"
                            v-model="overlapValue"
                            disabled="disabled"
                            name="overlap"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Finished Length: </span>
                        <md-field>
                          <input
                            type="number"
                            :min="1"
                            @blur="onFinishedLengthChange"
                            @input="onFinishedLengthChange"
                            v-model="finishedLength"
                            name="finished-length"
                          />
                        </md-field>
                        <p class="validmsg" v-show="FLZ > 0">Please specify a finished length that is an increment of .125".</p>
                      </div>
                      <div class="length-div">
                        <span>Right Return: </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model="rightReturnValue"
                            name="right-return"
                            disabled="disabled"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.lining-type
                    >Type of Lining<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="lining-type">
                    <h3 class="regularfont">Select Lining type:</h3>
                    <div class="select-radio">
                      <md-radio
                        v-model="liningselect"
                        name="rm-white"
                        value="RDSSW"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM Designer Super Sateen__White.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Super Sateen - White</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="rm-ivory"
                        value="RDSSI"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM Designer Thremafoam__Pale Ivory.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Super Sateen - Ivory</p></md-radio
                      >
                       <md-radio
                        v-model="liningselect"
                        name="ivory-inter-black"
                        value="RDLTI"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM_Designer_Lite-Tech_Non_FR_Blackout__Ivory.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Lite-Tech Non FR Blackout - Ivory</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="white-inter-black"
                        value="RDLTW"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM_Designer_Lite-Tech_Non_FR_Blackout__White.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Lite-Tech Non FR Blackout - White</p></md-radio
                      >
                    </div>
                    <div class="trim-pattern" v-if="['RDLTW', 'RDLTI'].includes(liningselect) && ['Pleated Three Prong', 'Pleated Two Prong','Three Prong Tacked at Top','Two Prong Tacked at Top'].includes(selectedStyleName)">
                      <span>BlackoutGuard&trade;</span>
                      <v-select
                        :options="optinterlining"
                        label="text"
                        :reduce="(optinterlining) => optinterlining.value"
                        :clearable="false"
                        :searchable="false"
                        v-model="blackoutguard"
                        placeholder="Please Select RM Designer Interlining"
                      ></v-select>
                    </div>
                    <p v-if="['RDLTW', 'RDLTI'].includes(liningselect) && ['Pleated Three Prong', 'Pleated Two Prong','Three Prong Tacked at Top','Two Prong Tacked at Top'].includes(selectedStyleName)" class="validmsg font-weight-bold" style="margin-top:10px;"><em>**BlackoutGuard&trade; is highly recommended for blackout lined drapery with lighter color face fabric. <a href="/wp-content/uploads/2026/09/BlackoutGuard-Sell-Sheet.pdf" target="_blank">View More Information</a></em></p>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.line
                    >Project Name<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="line">
                    <div class="measurement-div">
                      <div class="length-div linediv">
                        <md-field :md-counter="false">
                          <md-input
                            type="text"
                            v-model="line"
                            maxlength="50"
                            name="lineno"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.customernotes
                    >Notes<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="customernotes">
                    <div class="measurement-div">
                      <div class="length-div linediv">
                        <md-field>
                          <md-input
                            type="text"
                            v-model="customernotes"
                            name="customernotes"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-form>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
    <ProjectModal ref="project" />
    <b-modal
      id="printquote"
      ref="printquotemodal"
      title="Price to Display on Quote"
      title-tag="h3"
      ok-only
      modal-class="common_pop printquote"
    >
    <div class="radio-options">
      <md-field>
      <ul>
        <li><md-radio v-model="printquotetype" value="wholesale">Wholesale</md-radio></li>
        <li><md-radio v-model="printquotetype" value="markup"><div><md-input v-model="pqmarkupnum" type="number"></md-input><span class="md-suffix">% markup</span></div></md-radio></li>
      </ul>
      </md-field>
      <a @click="printQuoteGen" class="btn btn-dark btn-block">Print</a>
    </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ProjectModal from "@/views/ProjectModal/ProjectModal.vue";
import Select2 from './Select2.vue';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    CommonHead,
    CommonFoot,
    ProjectModal,
    Select2,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    } else {
      this.init();
    }
    console.log(this.$route.params.id, "params");
  },
  updated: function () {
    this.$nextTick(function () {
      this.doCalculation();
    });
  },
  data() {
    return {
      qty: 1,
      fabrictype_value: null,
      liningselectMap: {
        RDSSW: "RM Designer Super Sateen - White",
        RDSSI: "RM Designer Super Sateen - Ivory",
        RDLTI: "RM Designer Lite-Tech Non FR Blackout - Ivory",
        RDLTW: "RM Designer Lite-Tech Non FR Blackout - White",
      },
      colorCollapsed: false,
      currentStep: 0,
      fabrictype: [],
      selectedFabricType: null,
      selectedFabricTypeName: "",
      fabricname: [],
      selectedFabricName: "",
      selectedFabricNameValue: "",
      fabriccolors: [],
      selectedFabricColor: null,
      selectedFabricColorName: "",
      selectedFabricColorImg: "",
      grometcolor: [
          { value: "blue", text: "blue" },
          { value: "black", text: "black" },
          { value: "red", text: "red" },
          { value: "green", text: "green" },
        ],
      quantities: [],
      selectedQuantity: null,
      styles: [],
      selectedStyle: null,
      selectedStyleName: "",
      staticOptions: {
        pin: [],
        grommet: [],
      },
      styleOptionVisiblity: {
        grommet: false,
        pin: false,
      },
      styleOptionValues: {
        grommet: null,
        pin: null,
      },
      styleOptionNames: {
        grommet: "",
        pin: "",
      },
      blackoutguard: false,
      blackoutguardCost: 0,
      optinterlining:[
        { value: false, text: "No"},
        { value: true, text: "Yes"},
      ],
      styleSelectedDone: false,
      panelpairQty: 1,
      panelpairQtySheer: "PAIR",
      panelpairQtyName: "",
      overlapValue: 0,
      overlapSheer: "0",
      finishedLength: 1,
      FLZ:0,
      leftReturnValue: 3.5,
      rightReturnValue: 3.5,
      loadingName: false,
      loadingColor: false,
      finishedWidth: 0,
      dRodValue: 0,
      dFullnessValue: 3,
      liningselect: "RDSSW",
      calculationValue: "",
      lastCalculationState: {},
      rawCalculation: 0,
      rawDiscount:0,
      rawDiscountedAmount: 0,
      basePrice:0,
      interliningSurcharge:0,
      canSave: false,
      line: "",
      customernotes:"",
      cartOrderMsg: "",
      grommetByColor: { colors: [], sizes: {}, sizesIds: {} },
      selectedGrommetColor: null,
      selectedGrommetSize: null,
      cartform: new Form({
        itemid: "",
        inventcolorid: "",
        pc_type: "CDIQ",
        unitid: "",
        order_type: "CDI",
        quantity: 1,
        discountedprice:0,
        notes: "",
        user_id: "",
        cdi_id: "",
      }),
      printquotetype : "wholesale",
      pqmarkupnum:0,
    };
  },
  methods: {
    togglepromo() {
      $(".leftpromo").toggle();
      $(".ordershow").toggleClass("minusshow");
    },
    toggleColors(e) {
      if (
        e.target.localName !== "input" &&
        e.target.className.indexOf("vs_") === -1
      ) {
        this.colorCollapsed = this.fabriccolors.length > 0 ? !this.colorCollapsed : false;
      }
    },
    setCurrentStep(step) {
      switch (step) {
        case 1:
          this.resetName();
          this.resetColor();
          break;
        case 2:
          this.resetColor();
          break;
        case 3:
          this.colorCollapsed = true;
          break;
        case 4:
          // this.colorCollapsed = false;
          this.$root.$emit("bv::toggle::collapse", "top-style");
          break;
        default:
          break;
      }
      this.currentStep = step;
      console.log(step, "step");
    },
    reset() {
      this.qty =  1;
      this.fabrictype_value = null;
      this.selectedFabricType = null;
      this.selectedFabricTypeName = "";
      this.selectedFabricName = "";
      this.selectedFabricNameValue = "";
      this.selectedFabricColor = null;
      this.selectedFabricColorName = "";
      this.selectedFabricColorImg = "";
      this.selectedQuantity = null;
      this.selectedStyle = null;
      this.selectedStyleName = "";
      this.styleOptionVisiblity = {
        grommet: false,
        pin: false,
      };
      this.styleOptionValues = {
        grommet: null,
        pin: null,
      };
      this.styleOptionNames = {
        grommet: "",
        pin: "",
      };
      this.styleSelectedDone = false;
      this.panelpairQty = 1;
      this.panelpairQtySheer = "PAIR";
      this.panelpairQtyName = "";
      this.overlapValue = 0;
      this.overlapSheer = "0";
      this.finishedLength = 1;
      this.leftReturnValue = 3.5;
      this.rightReturnValue = 3.5;
      this.loadingName =  false;
      this.loadingColor =  false;
      this.finishedWidth =  0;
      this.dRodValue =  0;
      this.dFullnessValue =  3;
      this.liningselect = "RDSSW";
      this.calculationValue =  "";
      this.lastCalculationState =  {};
      this.rawCalculation =  0;
      this.rawDiscount = 0;
      this.rawDiscountedAmount =  0;
      this.basePrice = 0;
      this.interliningSurcharge = 0;
      this.canSave =  false;
      this.line =  "";
      this.customernotes = "";
      this.cartOrderMsg =  "";
      this.selectedGrommetColor = null;
      this.selectedGrommetSize = null;
      this.cartform = new Form({
        itemid: "",
        inventcolorid: "",
        pc_type: "CDIQ",
        unitid: "",
        order_type: "CDI",
        quantity: 1,
        discountedprice:0,
        notes: "",
        user_id: "",
        cdi_id: "",
      }),
      $('.collapse.show').collapse('hide');
      $('html, body').animate({scrollTop: 0 },100);
      this.setCurrentStep(1);
    },
    resetColor() {
      this.selectedFabricColor = "";
      this.selectedFabricColorName = "";
      this.selectedFabricColorImg = "";
      this.fabriccolors = [];
      // this.colorCollapsed = false;
    },
    resetName() {
      this.selectedFabricName = "";
      this.selectedFabricNameValue = "";
      this.fabricname = [];
    },
    loadTypes(cb) {
      this.setCurrentStep(0);
      this.$store
        .dispatch("loadQuickShipTypes")
        .then((types) => {
          this.fabrictype = types.map((d) => ({ value: d.id, text: d.name }));
          // this.fabrictype = types.filter(e => e.id != 'Sheer').map((d) => ({ value: d.id, text: d.name }));
          this.setCurrentStep(1);
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loadTypes();
        });
    },
    loadNames(selectedOption, cb) {
      this.selectedFabricType = selectedOption.value;
      this.selectedFabricTypeName = selectedOption.text;
      this.setCurrentStep(1);
      this.loadStyles(this.selectedFabricType);
      this.loadingName = true;
      this.$store
        .dispatch("loadQuickShipNames", selectedOption.value)
        .then((names) => {
          this.fabricname = names.map((d) => ({ value: d.id, text: d.name }));
          this.loadingName = false;
          this.setCurrentStep(2);
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loadNames(selectedOption);
        });
    },
    loadColors(selectedOption, cb) {
      this.selectedFabricNameValue = selectedOption.text;
      // this.selectedFabricName = selectedOption.value;
      this.setCurrentStep(2);
      this.loadingColor = true;
      this.$store
        .dispatch("loadPromoColors", selectedOption.value)
        .then((names) => {
          this.fabriccolors = names;
          this.loadingColor = false;
          this.setCurrentStep(3);
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loadColors(selectedOption);
        });
    },
    selectColor(color) {
      this.selectedFabricColor = color.INVENTCOLORID;
      this.selectedFabricColorName = color.COLORNAME;
      this.selectedFabricColorImg = color.IMAGE;
      if (this.$route.params.id) {
        this.setCurrentStep(5);
      }else{
        this.setCurrentStep(4);
      }
      console.log(color, "color selected");
    },
    loadQuantity(programId, value) {
      console.log(programId, "programId");
      this.$store
        .dispatch("loadQuickShipQuantity", { programId, value })
        .then((quantities) => {
          console.log(quantities, "quantities");
          this.quantities = quantities;
          this.onPanelPairSelect(this.panelpairQty);
        })
        .catch((e) => {
          this.loadQuantity(programId, value);
        });
    },
    loadStyles(programId) {
      console.log(programId, "programId styles");
      this.$store
        .dispatch("loadQuickShipStyles", programId)
        .then((styles) => {
          console.log(styles, "styles");
          this.styles = styles;
          // if (this.styles.length) {
            // this.selectedStyle = this.styles[0].id;
            // this.selectedStyleName = this.styles[0].name;
            // this.onStyleSelect(this.selectedStyle);
          // }
        })
        .catch((e) => {
          this.loadStyles(programId);
        });
    },
    onPanelPairSelect(value) {
      if (this.selectedFabricType != "Sheer") {
        this.quantities.forEach((q) => {
          if (parseFloat(q.Widths) === parseFloat(value)) {
            this.panelpairQtyName = q.Description;
            if (parseInt(value) === 1 || parseInt(value) === 2) {
              this.dRodValue = (q.Inches - this.leftReturnValue) - this.rightReturnValue;
            }else{
              this.dRodValue = ((q.Inches - this.overlapValue) - this.leftReturnValue) - this.rightReturnValue;
            }
          }
        });
      }
      if (parseInt(value) === 1 || parseInt(value) === 2) {
        this.overlapValue = 0;
      } else {
        if(this.selectedStyle == "GR"){
            this.overlapValue = 0;
        }else{
            this.overlapValue = 3.5;
        }
      }
      console.log(value, "e");
    },
    onStyleSelect(value) {
      this.styleSelectedDone = true;
      this.setCurrentStep(5);
      Object.keys(this.styleOptionVisiblity).forEach((key) => {
        this.styleOptionVisiblity[key] = false;
      });
      this.styles.forEach((style) => {
        if (style.id === value) {
          this.selectedStyleName = style.name;
        }
      });
      this.leftReturnValue = 3.5;
      this.rightReturnValue = 3.5;
      this.overlapValue = 0;
      switch (value) {
        case "GR":
          this.styleOptionVisiblity.grommet = true;
          this.styleOptionValues.pin = "0";
          this.leftReturnValue = 0;
          this.rightReturnValue = 0;
          this.overlapValue = 0;
          break;
        case "RP":
          this.styleOptionValues.pin = "0";
          break;
        case "PL3":
          this.styleOptionVisiblity.pin = true;
          break;
        default:
          this.styleOptionVisiblity.pin = true;
          break;
      }
      this.remapNamesToStyle();
      this.loadQuantity(this.selectedFabricType, value);
    },
    loadStaticOptions(cb) {
      this.$store
        .dispatch("loadQuickShipStaticOptions")
        .then((staticOptions) => {
          this.staticOptions = {
            ...staticOptions,
          };
          this.staticOptions.grommet = this.staticOptions.grommet.map((d) => ({
            ...d,
            image: d.image
              ? "/shop/attachments/promo/" + d.image
              : "/shop/images/rm-sateen-white.jpg",
          }));
          let grommetByColor = { colors: [], sizes: {}, sizesIds: {} };
          this.staticOptions.grommet.forEach((d) => {
            if (grommetByColor.colors.includes(d.Color)) {
              grommetByColor.sizes[d.Color].push(d);
              grommetByColor.sizesIds[d.Color].push(d.Size);
            } else {
              grommetByColor.colors.push(d.Color);
              grommetByColor.sizes[d.Color] = [d];
              grommetByColor.sizesIds[d.Color] = [d.Size];
            }
          });

          this.grommetByColor = grommetByColor;
          
          Object.keys(this.styleOptionValues).forEach((key) => {
            if (key in this.staticOptions) {
              if (this.staticOptions[key].length) {
                switch (key) {
                  case "grommet":
                    this.styleOptionValues[key] = this.staticOptions[
                      key
                    ][0].SizeColor;
                    this.selectedGrommetColor = 0;
                    this.selectedGrommetSize =
                      grommetByColor.sizesIds[grommetByColor.colors[0]][0];
                    break;
                  case "pin":
                    this.styleOptionValues[key] = this.staticOptions[
                      key
                    ][0].PinSetSize;
                    break;

                  default:
                    this.styleOptionValues[key] = this.staticOptions[
                      key
                    ][0].Value;
                    break;
                }
              }
            }
          });
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loadStaticOptions();
        });
    },
    remapNamesToStyle() {
      Object.keys(this.styleOptionValues).forEach((key) => {
        if (key in this.staticOptions) {
          if (this.staticOptions[key].length) {
            switch (key) {
              case "grommet":
                this.styleOptionNames.grommet = this.styleOptionValues.grommet;
                break;
              case "pin":
                var optionsfilter = this.staticOptions[key].filter(
                  (d) => this.styleOptionValues[key] === d.PinSetSize
                );
                if(optionsfilter.length > 0){
                  this.styleOptionNames[key] = optionsfilter[0].PinSetDiscFull;
                }
                break;

              default:
                if(this.styleOptionValues[key]){
                  this.styleOptionNames[key] = this.staticOptions[key].filter(
                    (d) => this.styleOptionValues[key] === d.Value
                  )[0].Description;
                }
                break;
            }
          }
        }
      });
    },
    onFinishedLengthChange() {
      if (parseInt(this.finishedLength) <= 0) {
        this.finishedLength = 1;
      }

      if (parseInt(this.finishedLength) >= 120) {
        this.finishedLength = 120;
      }
      this.FLZ = Math.ceil(this.finishedLength % 0.125);
      if(this.FLZ == 0){
        this.canSave = true;
      }else{
        this.canSave = false;
      }
    },
    init() {
      this.loadTypes();
      this.loadStaticOptions();
    },
    calculateFW() {
      if (this.panelpairQtySheer === "PANEL") {
        this.finishedWidth = parseFloat(this.dRodValue) + (parseFloat(this.leftReturnValue) + parseFloat(this.rightReturnValue));
      } else {
        this.finishedWidth = parseFloat(this.dRodValue) + (parseFloat(this.leftReturnValue) + parseFloat(this.rightReturnValue) + parseFloat(this.overlapSheer));
      }
      let value = this.panelpairQty;
      if(this.selectedFabricType != "Sheer"){
        this.quantities.forEach((q) => {
          if (parseFloat(q.Widths) === parseFloat(value)) {
            this.panelpairQtyName = q.Description;
            if (parseInt(value) === 1 || parseInt(value) === 2) {
              this.dRodValue = (q.Inches - this.leftReturnValue) - this.rightReturnValue;
            }else{
              this.dRodValue = ((q.Inches - this.overlapValue) - this.leftReturnValue) - this.rightReturnValue;
            }
          }
        });
      }
      console.log(this.finishedWidth, "calculateFW");
    },
    doCalculation() {
      if ((this.currentStep >= 4) & (this.finishedLength != "")) {
        let caseId = 0;
        let lined = "L";
        let width = this.panelpairQty;
        let program = this.selectedFabricType;
        let fabric = this.selectedFabricName.value;
        let color = this.selectedFabricColor;
        let style = this.selectedStyle;
        let interlining = 'No';
        let radLen = this.finishedLength || 1;
        let grommet = this.styleOptionValues.grommet;
        let finishedWidth = 0;
        let workroom = 'quickship';
        if (isNaN(this.finishedWidth)){
          finishedWidth = 0;
        } else{
          finishedWidth = this.finishedWidth;
        }
        let panelPair = this.panelpairQtySheer;

        if(this.liningselect == "RDLTI" || this.liningselect == "RDLTW"){
          interlining = this.liningselect;
        }
        
        if(!['RDLTW', 'RDLTI'].includes(this.liningselect) || !['Pleated Three Prong', 'Pleated Two Prong','Three Prong Tacked at Top','Two Prong Tacked at Top'].includes(this.selectedStyleName)){
          this.blackoutguard = false;
          this.blackoutguardCost = 0;
        }
        let blackoutguard = this.blackoutguard;
        if (this.selectedFabricType != "Sheer") {
          if (this.panelpairQtyName.includes("Panel")) {
            this.panelpairQtySheer = "PANEL";
          } else {
            this.panelpairQtySheer = "PAIR";
          }
        }
        
        let finalData = {};
        switch (caseId) {
          case 0:
            finalData = {
              case: caseId,
              lined,
              width,
              program,
              fabric,
              color,
              style,
              radLen,
              interlining,
              panelPair,
              blackoutguard,
              workroom
            };
            break;
          default:
            finalData = {
              case: caseId,
              fabric,
              panelPair,
              finishedWidth,
              beadedWeight,
              bottomHeader,
              workroom
            };
            break;
        }
        if (finishedWidth === 0 && caseId === 2) {
          return;
        }
        if (Object.keys(this.lastCalculationState).length) {
          let hasChanged = false;
          Object.keys(this.lastCalculationState).forEach((key) => {
            if (!hasChanged)
              hasChanged = this.lastCalculationState[key] != finalData[key];
          });
          if (!hasChanged) {
            console.log("nothing changed");
            return;
          }
        }
        this.canSave = false;
        this.calculationValue = "Calculating...";
        this.lastCalculationState = finalData;
        this.$store
          .dispatch("loadPromoCalculation", finalData)
          .then((calculation) => {
            if (calculation.status) {
              if (calculation.value.length) {
                let val = calculation.value[0].Total || calculation.value[0].Price;
                if (parseFloat(val) > 0) {
                  this.calculationValue = `$${parseFloat(val).toFixed(2)}`;
                  this.rawCalculation = parseFloat(val);
                  this.rawDiscount = parseFloat(calculation.Discount);
                  let discounted = (parseFloat(val) * this.rawDiscount) / 100;
                  this.rawDiscountedAmount = parseFloat(val) - parseFloat(discounted);
                  this.basePrice = parseFloat((calculation.value[0].basePrice) * 2).toFixed(2);
                  this.interliningSurcharge = parseFloat((calculation.value[0].interliningSurcharge) * 2).toFixed(2);
				  this.blackoutguardCost = parseFloat((calculation.value[0].blackoutGuardSurcharge) * 2).toFixed(2);
                  this.FLZ = Math.ceil(this.finishedLength % 0.125);
                  if(this.FLZ == 0){
                    this.canSave = true;
                  }else{
                    this.canSave = false;
                  }
                }
              }
            }
            console.log(calculation, "done calculation");
          })
          .catch((e) => {
            console.log(e);
            this.doCalculation();
          });
        console.log(finalData, "doing calculation1");
      }
    },
    saveData(updateProject = false) {
      return new Promise((resolve, reject) => {
        if (!this.line.length) {
          this.$notify({
            text: "Please enter project name",
            type: "error",
          });
          reject("INVALID_LINE_NOTE");
          return;
        }
        if (this.selectedFabricType != "Sheer") {
          this.dFullnessValue = 2.5;
          this.bottomPocket = 0.2;
          if (this.panelpairQtyName.includes("Panel")) {
            this.panelpairQtySheer = "PANEL";
          } else {
            this.panelpairQtySheer = "PAIR";
          }
        }
        let olapval = this.overlapValue;
        this.$store
          .dispatch(updateProject ? "loadQuickShipUpdateData" : "loadQuickShipAddData", {
            name: this.line,
            programId: this.selectedFabricType,
            fabricId: this.selectedFabricName.value,
            colorId: this.selectedFabricColor,
            liningType: this.liningselect,
            blackoutguard: this.blackoutguard,
            style: this.selectedStyle,
            pin: this.styleOptionValues.pin,
            panelpairqty: this.panelpairQty,
            leftReturn: this.leftReturnValue,
            rightReturn: this.rightReturnValue,
            finishedLength: this.finishedLength,
            overlap: olapval,
            rodInches: this.dRodValue,
            panelpairsheer: this.panelpairQtySheer,
            fullness: this.dFullnessValue,
            calculation: this.rawCalculation,
            discount: this.rawDiscount,
            qty: this.qty,
            grommet: this.styleOptionValues.grommet,
            product_name: this.panelpairQtyName,
            customernotes:this.customernotes,
            otherdata: {
              FabricType: this.selectedFabricTypeName,
              FabricName: this.selectedFabricNameValue + ' ' +this.selectedFabricColorName,
              Style: this.selectedStyleName,
              ColorSize: this.styleOptionNames.grommet,
              PinSetting: this.styleOptionNames.pin,
              PanelsPairsQty: this.panelpairQtyName,
              LeftReturn: this.leftReturnValue,
              RightReturn: this.rightReturnValue,
              Overlap: this.overlapValue,
              FinishedLength: this.finishedLength,
              PairPanel: this.panelpairQtySheer,
              OverlapInches: this.overlapSheer,
              Fullness: this.dFullnessValue,
              RodInches: this.dRodValue,
              Lining: this.liningselectMap[this.liningselect],
              BlackoutGuard: this.blackoutguard,
              ProjectName: this.line,
              Notes: this.customernotes,
              BasePrice: this.basePrice,
              InterliningSurcharge: this.interliningSurcharge,
              BlackoutGuardSurcharge: this.blackoutguardCost,
              Total: (this.qty * this.rawCalculation),
            },
            ...(updateProject ? { id: this.$route.params.id } : {}),
          })
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject("FAILED_TO_SAVE");
          });
      });
    },
    onChangeQTY() {
      if (parseInt(this.qty) <= 0) {
        this.qty = parseInt(1);
      }
    },
    decrement() {
      if (this.qty > 1) this.qty = parseInt(this.qty) - 1;
    },
    increment() {
      this.qty = parseInt(this.qty) + 1;
    },
    addtocartpanel() {
      if (this.$route.query.hasOwnProperty('cart')) {
          this.saveData(true).then((data) => {
            this.updateCart(data).then((rsdata) => {
              this.$notify({
                text: "10 Day Quick Ship update successfully",
                type: "success",
              });
              this.$router.push({ name: "cart" });
            });
          })
          .catch((error) => {
            console.log(error);
          });
          return;
      }
      this.$store
        .dispatch("loadCart", this.user.accountnumber)
        .then((minicart) => {
          var submit = 1;
          if (minicart.data.ITEMS.length > 0) {
            if (!(minicart.data.ITEMS[0].PC_TYPE == "CDI" || minicart.data.ITEMS[0].PC_TYPE == "CDIQ" || minicart.data.ITEMS[0].PC_TYPE == "CDIP")) {
              if (minicart.data.ITEMS[0].PC_TYPE != this.cartform.pc_type) {
                this.cartOrderMsg = `${this.cartform.pc_type == "CDIQ" ? "Quick Ship" : this.cartform.pc_type} orders cannot be placed with ${minicart.data.ITEMS[0].COLORWORKS == "1" ? 'Colorworks' : minicart.data.ITEMS[0].PC_TYPE} orders. Please finish placing your ${minicart.data.ITEMS[0].COLORWORKS == "1" ? 'Colorworks' : minicart.data.ITEMS[0].PC_TYPE} order and then place your ${this.cartform.pc_type == "CDIQ" ? "Quick Ship" : this.cartform.pc_type} order separately.`
                submit = 0;
                this.$refs["cartmodal"].show();
                return false;
              }
            }
          }
          if (submit == 1) {
            this.saveData().then((data) => {
              this.cartform.itemid = data.fabricId;
              this.cartform.inventcolorid = data.colorId;
              this.cartform.user_id = this.user.accountnumber;
              this.cartform.cdi_id = data.id;
              this.cartform.quantity = data.qty;
              this.cartform.discountedprice = this.rawDiscountedAmount;
              this.$store
                .dispatch("AddtoCart", {
                  form: this.cartform,
                })
                .then((rsdata) => {
                  if (rsdata.data.success == false) {
                    this.cartOrderMsg = rsdata.data.message;
                    this.$refs["cartmodal"].show();
                  } else {
                    this.$notify({
                      text: "Product added to cart",
                      type: "success",
                    });
                    this.reset();
                    this.isLoading = true;
                    this.$store
                      .dispatch("loadCart", this.user.accountnumber)
                      .finally(() => {
                        this.isLoading = false;
                      });
                  }
                })
                .catch((error) => {
                  if (this.cartform.hasErrors()) {
                    this.$notify({
                      text:
                        "There is a validation error. Please correct the fields outlined in red and try again.",
                      type: "error",
                    });
                  } else {
                    this.$notify({
                      text: "Something went wrong!",
                      type: "error",
                    });
                  }
                });
            });
          }
        });
    },
    updateCart(data){
      return new Promise((resolve, reject) => {
        this.cartform.itemid = data.fabricId;
        this.cartform.inventcolorid = data.colorId;
        this.cartform.user_id = this.user.accountnumber;
        this.cartform.cdi_id = data.id;
        this.cartform.quantity = data.qty;
        this.cartform.discountedprice = this.rawDiscountedAmount;
        this.$store.dispatch("updateCDICart", {
          form: this.cartform,
        }).then((rsdata) => {
          resolve(rsdata);
        }).catch((e) => {
          //console.log(e);
          reject("CART_FAILED_TO_UPDATE");
        });
      });
    },
    saveToProject() {
      if (this.$route.params.id) {
        this.saveData(true)
          .then((data) => {
            this.$notify({
              text: "10 Day Quick Ship update successfully",
              type: "success",
            });
          })
          .catch((error) => {
            console.log(error);
          });
        return;
      }
      this.saveData()
        .then((data) => {
          this.$refs.project.show(data.id,"2");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onGrommetColorChange(value) {
      this.selectedGrommetSize = this.grommetByColor.sizesIds[this.selectedGrommetColor][0];
      this.styleOptionValues.grommet = this.selectedGrommetSize + " " + value;
      this.remapNamesToStyle();
    },
    onGrommetSizeChange(value) {
      this.styleOptionValues.grommet = value + " " + this.selectedGrommetColor;
      console.log(value, this.selectedGrommetSize);
      this.remapNamesToStyle();
    },
    loadData(id) {
      this.$store
        .dispatch("loadQuickShipGetData", id)
        .then((data) => {
          this.line = data.name;
          this.customernotes = data.customernotes;
          this.selectedStyle = data.style;
          this.liningselect = data.liningType;
          this.panelpairQty = data.panelpairqty;
          this.leftReturnValue = data.leftReturn;
          this.rightReturnValue = data.rightReturn;
          if (data.programId == "Sheer") {
            this.overlapSheer = data.overlap;
          } else {
            this.overlapValue = data.overlap;
          }
          this.panelpairQtySheer = data.panelpairsheer;
          this.dFullnessValue = data.fullness;
          this.rawCalculation = data.calculation;
          this.qty = data.qty;
          this.styleOptionValues.grommet = data.grommet;
          this.loadTypes(() => {
            this.fabrictype.forEach((d) => {
              if (d.value == data.programId) {
                this.fabrictype_value = { value: data.programId, text: d.text };
              }
            });
            this.selectedFabricType = data.programId;
            this.loadStaticOptions(() => {
              this.loadNames(
                {
                  value: this.fabrictype_value.value,
                  text: this.fabrictype_value.text,
                },
                () => {
                  this.fabricname.forEach((d) => {
                    if (d.value == data.fabricId) {
                      this.selectedFabricName = {
                        value: data.fabricId,
                        text: d.text,
                      };
                      this.loadColors(
                        { value: data.fabricId, text: d.text },
                        () => {
                          this.dRodValue = data.rodInches;
                          this.fabriccolors.forEach((d) => {
                            if (d.INVENTCOLORID == data.colorId) {
                              this.selectColor(d);
                              this.onStyleSelect(data.style);
                              this.styleOptionNames.grommet = data.grommet;
                              if(data.style == 'GR'){
                                this.selectedGrommetColor = this.staticOptions["grommet"].filter(
                                  (d) => data.grommet == d.SizeColor
                                )[0].Color;
                                this.selectedGrommetSize = this.staticOptions["grommet"].filter(
                                  (d) => data.grommet == d.SizeColor
                                )[0].Size;
                              }
                              if(data.pin){
                                this.styleOptionValues.pin = data.pin;
                                this.styleOptionNames.pin;
                                var optionsfilter = this.staticOptions["pin"].filter(
                                  (d) => this.styleOptionValues["pin"] === d.PinSetSize
                                );
                                if(optionsfilter.length > 0){
                                  this.styleOptionNames["pin"] = optionsfilter[0].PinSetDiscFull;
                                }
                              }
                            }
                          });
                          this.finishedLength = Number(data.finishedLength);
                          this.blackoutguard = Boolean(Number(data.blackoutguard));
                        }
                      );
                    }
                  });
                }
              );
            });
          });
          // this.currentStep = 5;
          console.log(data, "data get data");
        })
        .catch((e) => {
          this.loadData(id);
          console.log(e);
        });
    },
    printQuote(){
      this.$refs["printquotemodal"].show();
    },
    printQuoteGen(){
      this.saveData().then((data) => {
          const url = '/shop/quick-ship-print?type='+this.printquotetype+'_'+this.pqmarkupnum+'&id='+data.id;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style>
</style>